import {
  Row,
  Col,
  Form,
} from "react-bootstrap";

const PlaylistsIsLive = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked
) => {
  return (
    <small>
      <Row className="pt-2 justify-content-evenly">
        {/* <Col xs={1}></Col> */}
        <Col
          xs={3}
          className={
            programDetails.isLive.isDirty
              ? "border border-2 border-danger text-danger mx-2 pt-2"
              : "border border-2 border-danger mx-2 pt-2 "
          }
        >
          <Row>
            <Col xs={9}>
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsLive"}
                label={"Is Live"}
                checked={programDetails.isLive.isLive ? true : false}
                defaultValue={programDetails.isLive.isLive}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isLive: {
                      ...programDetails.isLive,
                      isLive: e.target.checked,
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
            <Col className="text-end ">
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsLiveIsDirty"}
                checked={programDetails.isLive.isDirty ? true : false}
                defaultValue={programDetails.isLive.isDirty}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isLive: {
                      ...programDetails.isLive,
                      isDirty: e.target.checked,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
          </Row>
        </Col>
        <Col
          xs={3}
          className={
            programDetails.isAvailable.isDirty
              ? "border border-2 border-success text-danger pt-2"
              : "border border-2 border-success pt-2"
          }
        >
          <Row>
            <Col xs={9}>
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsLiveIsAvailable"}
                label={"Available"}
                checked={programDetails.isAvailable.isAvailable ? true : false}
                defaultValue={programDetails.isAvailable.isAvailable}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isAvailable: {
                      ...programDetails.isAvailable,
                      isAvailable: e.target.checked,
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
            <Col className="text-end ">
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsAvailableIsDirty"}
                checked={programDetails.isAvailable.isDirty ? true : false}
                defaultValue={programDetails.isAvailable.isDirty}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isAvailable: {
                      ...programDetails.isAvailable,
                      isDirty: e.target.checked,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
          </Row>
        </Col>
        <Col
          xs={3}
          className={
            programDetails.isLocked.isDirty
              ? "border border-2 border-warning text-danger mx-2 pt-2 "
              : "border border-2 border-warning mx-2 pt-2"
          }
        >
          <Row>
            <Col xs={9}>
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsLocked"}
                label={"Locked"}
                checked={programDetails.isLocked.isLocked ? true : false}
                defaultValue={programDetails.isLocked.isLocked}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isLocked: {
                      ...programDetails.isLocked,
                      isLocked: e.target.checked,
                      isDirty: true,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
            <Col className="text-end ">
              <Form.Check // prettier-ignore
                type={"checkbox"}
                isValid
                id={"programIsLockedIsDirty"}
                checked={programDetails.isLocked.isDirty ? true : false}
                defaultValue={programDetails.isLocked.isDirty}
                onChange={(e) => {
                  setProgramDetails({
                    ...programDetails,
                    isLocked: {
                      ...programDetails.isLocked,
                      isDirty: e.target.checked,
                    },
                  });
                  setFormEdited(true);
                }}
                disabled={isLocked}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </small>
  );
};
export default PlaylistsIsLive;
